// Face Scan API Types

export interface UserDemographics {
  name: string;
  phone: string;
  dob: string;
  gender: 'male' | 'female';
  age: number;
  height: number; // in cm
  weight: number; // in kg
  email?: string;
}

export interface FaceScanModuleData {
  raw_intensity: number[];
  ppg_time: number[];
  average_fps: number;
  emotion: string;
  scanType: string;
  timestamp: string;
  faceScanConfigs: {
    faceVitalMethod?: string;
    takeScreenshot?: boolean;
  };
  uid?: string;
}

export interface SkinScanData {
  image: string; // base64 encoded image
  timestamp?: string;
}

export interface FaceScanAPIRequest extends FaceScanModuleData, UserDemographics {
  hospital_id?: string;
  org_name?: string;
  user_name?: string;
}

export interface SkinScanAPIRequest {
  image_base64: string;
  org_name?: string;
}

export interface FaceScanAPIResponse {
  statusCode: number;
  scan_id: string;
  wellness_score: number;
  health_risk_score: string;
  isFallbackData: string;
  vitals: {
    heart_rate: number;
    oxy_sat_prcnt: number;
    resp_rate: number;
    bp_sys: number;
    bp_dia: number;
    hypertension_risk_score: number;
    hypertension_risk_category: string;
    hypertension_risk_percentage: number;
  };
  original_vitals?: {
    heart_rate_bpm: number;
    respiration_rate_bpm: number;
    stress: number;
    stress_index: number;
    hrv_sdnn: number;
    hrv_rmssd: number;
    spo2: number;
    pNN50_per: number;
    overall_health_score: number;
    sbp: number;
    dbp: number;
    hemoglobin: number;
    hba1c: number;
    hba1c_risk_score: number;
    hba1c_risk: string;
    hba1c_risk_percentage: number;
    cardiac_load: number;
    cardiac_load_index: number;
    cardiac_load_category: string;
    cardiac_load_risk_percentage: number;
    hypertension_risk_score: number;
    hypertension_risk_category: string;
    hypertension_risk_percentage: number;
    hrvScore: number;
    heart_utilized: number;
    HRMax: number;
    HRR: number;
    THRR: number[];
    vo2max: number;
    cardiac_out: number;
    map: number;
    bmi: number;
    bloodvolume: number;
    tbw: number;
    tbwp: number;
    bodyfat: number;
    bmr: number;
    tdee: number;
  };
  metadata?: {
    device: string;
    fps: number;
    physiological_scores?: any;
    heartrate_time?: number[];
    resp_rate_time?: number[];
    heart_scores?: any;
    cardiovascular?: any;
    glucose_info?: any;
  };
  timestamp?: string;
  request_id?: string;
}

export interface SkinScanAPIResponse {
  skin_report: {
    skin_score: number;
    skin_grade: string;
    estimated_skin_age: number;
    parameters: {
      [key: string]: {
        score: number;
        maximum_score: number;
        comment: string;
        label: string;
      };
    };
    summary_and_recommendations: {
      'Morning Routine': string[];
      'Evening Routine': string[];
      'Weekly Treatments': string[];
      'Lifestyle Tips': string[];
    };
  };
  request_id: string;
  timestamp: string;
}

export interface PostMessageEvent {
  type: 'scan_complete' | 'scan_error' | 'scan_progress' | 'screenshot';
  payload?: FaceScanModuleData;
  error?: string;
  progress?: number;
  data?: any;
}

export enum ScanStep {
  USER_INFO = 'user_info',
  SCANNING = 'scanning',
  PROCESSING = 'processing',
  RESULTS = 'results',
  ERROR = 'error'
}
